export default {
  setCaluploads(state, { caluploads }) {
    state.caluploads = caluploads;
  },
  deleteCalfile(state, { filename }) {
    const caluploads = [...state.caluploads];
    const deleteIndex = caluploads.findIndex(c => c.raw === filename);
    if (deleteIndex !== 1) {
      caluploads.splice(deleteIndex, 1);
      state.caluploads = caluploads;
    }
  },
};

